import React, { Component } from "react";
import {
  storyTemplates,
  checkUploadType,
  uploadPreview,
} from "../../../utils/constants";
import {
  Row,
  Col,
  Label,
  Button,
  CardTitle,
  CardText,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import Toggle from "react-toggle";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import classnames from "classnames";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actionCreators from "../../../modules/actions/index";
import ReactPlayer from "react-player/lazy";
import Checkbox from "rc-checkbox";

class BannerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      description: {
        value: "",
      },
      setBannerImgPreview: [],
      title: "",
      cleanDesc: true,
      disableCreate: false,
      rejectedFiles: [],
      ogp: { urlScrape: false, requestUrl: "" },
      image: "",
      imageUrl: "",
      searchImg: "",
      bannerImg: null,
      privacy: true,
      isBannerOpen: false,
    };
    this.timer = null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isBannerOpen != prevProps.isBannerOpen) {
      this.setState({
        setBannerImgPreview: [],
        searchImg: "",
      });
    }
  }

  removeBannerImg = () => {
    this.setState({ bannerImg: null });
    this.props.removeBannerImg();
  };

  bannerSelectedHandler = (e) => {
    console.log("bannerIMG");
    console.log("e: ", e.target.files);
    let { setBannerImgPreview } = this.state;
    this.setState({ imageError: null });
    if (e.target.files[0]) {
      let file = e.target.files[0];

      let obj = {
        name: file.name,
        type: file.type,
        size: file.size,
        file,
        datetime: Date.now().toString(),
        isUploaded: true,
        preview: URL.createObjectURL(file),
        isAccepted: checkUploadType(file.type),
      };
      let res = uploadPreview(obj);
      console.log("res: ", res);

      if (res.isAccepted) {
        this.setState((prevState) => ({
          setBannerImgPreview: prevState.setBannerImgPreview.concat(res),
          imageError: null,
        }));
        // Array.from(e.target.files).map(file=> URL.revokeObjectURL(file))
      } else {
        this.setState({
          rejectedFiles: res,
          imageError: 2,
        });
      }

      Array.from(e.target.files).map((file) => URL.revokeObjectURL(file));
    }
  };

  handleSelectImg = (photo, details, name, url, id) => {
    console.log(photo, details, name, url, id);
    let result = {
        ...photo,
        details,
        name,
        url,
        id,
      },
      { bannerImg } = this.state;
    console.log("change image---", result);
    if (bannerImg == null || (bannerImg && bannerImg.id != id)) {
      result = result;
    } else {
      result = null;
    }
    result =
      bannerImg == null || (bannerImg && bannerImg.id != id) ? result : null;
    this.setState({ bannerImg: result });
    this.props.setBannerImg(result);
  };

  renderUploadPreview = (source) => {
    let { bannerImg } = this.state;
    let mb = 1024 * 1024;
    return source.map((photo, idx) => {
      let url, alt, details, id, name;
      if (photo.isUploaded) {
        name = photo.name;
        // type: photo.type,
        // size: photo.size,

        details = `${photo.type} and size:${(photo.size / mb).toFixed(2)}mb`;
        // file
        url = photo.preview;
        id = photo.preview;
        // isAccepted:checkUploadType(file.type)
      } else {
        id = photo.id;
        details = photo.photographer;
        url = photo.src.landscape;
        // file={...photo.src}
        name = photo.alt;
      }

      return (
        <span
          key={idx}
          className="col-xs-6 col-md-6 col-lg-6 grp_baner_modal_image_item"
        >
          <span
            className={
              photo.isAccepted == false
                ? "storyUploadPreviewImg rejectedFilesContainer"
                : "storyUploadPreviewImg"
            }
          >
            <img src={url} className="fileUploadSize" />
            {/* <span key={id+idx} onClick={()=>this.removeImage(id)} className="removeTaskUpload">
					<span className='flaticon-trash'/></span> */}
            <Checkbox
              className="grp_baner_modal_image_checkbox"
              checked={bannerImg && bannerImg.id == id}
              type="checkbox"
              onClick={() =>
                this.handleSelectImg(photo, details, name, url, id)
              }
            />
            {/* photo, details,name, url, id */}
            {/* <span className='flaticon-trash'/> */}
            {/* </span> */}

            <div className="grp_baner_modal_image_item_details">
              <span className="grp_baner_modal_image_item_details_title">
                {alt}
              </span>
              <span className="grp_baner_modal_image_item_details_author">
                {details}
              </span>
              {/* {photo.isAccepted==false?
					<span className="previewUploadFileError">
					  The following file will not be uploaded because of its file type
					</span>
					:null} */}
            </div>
          </span>
        </span>
      );
    });
  };

  removeImage = (photo) => {
    let { setBannerImgPreview } = this.state;
    let { preview } = photo;
    setBannerImgPreview.map((el) => URL.revokeObjectURL(el.file));
    let result = setBannerImgPreview.filter((e) => e.preview != preview);
    URL.revokeObjectURL(preview);
    URL.revokeObjectURL(photo.file);
    this.setState({ setBannerImgPreview: result });
  };

  queryDelay = ({ target }) => {
    let { searchImg } = this.state;
    let { value } = target;
    this.setState({ searchImg: value });
    clearTimeout(this.timer);
    if (searchImg.trim() != value.trim()) {
      this.timer = setTimeout(() => {
        this.imageSearch(value);
      }, 1000);
    }
  };

  imageSearch = (val) => {
    let that = this;
    axios
      .post(url.searchImages, { imageSearch: val, noLoader: true })
      .then(({ data }) => {
        that.setState({ setBannerImgPreview: data.data.photos });
      });
  };

  handleClick = (event) => {
    const { target = {} } = event || {};
    target.value = "";
  };

  render() {
    //suggest, showArchived, isSentiment, isAnonymous, topicsSelected, selectedFilter, filters, topics, disableSubmit, stories, collapseCompleted, categoryDefinitionPopoverOpen, archievedStories, showRemoveFeedConfirmationModal,
    let {
      setBannerImgPreview,
      bannerImg,
      showBannerModal,
      searchImg,
      image,
      imageUrl,
      ogp,
    } = this.state;
    let { isBannerOpen } = this.props;

    return (
      <Modal
        isOpen={isBannerOpen}
        className={`${
          this.props.from_module == "toolkit"
            ? "tk_banner_img_css_container"
            : ""
        } dashboardViewModalContainer createModalContainer grp_baner_modal_container`}
      >
        <ModalHeader
          className="dashboardHeader"
          charCode="X"
          toggle={this.props.openBannerModal}
        >
          <div className="dashboardModalTitle">
            {this.props.customTitle || "Select a Group Banner Image"}{" "}
          </div>
        </ModalHeader>

        <ModalBody style={{ paddingLeft: "25px", paddingRight: "25px" }}>
          <div className="">
            <div className="grp_baner_modal_container_image_options_container">
              <div className="grp_baner_modal_container_search_img_container">
                <span className="grp_baner_modal_container_search_img_txt">
                  Type a theme or subject
                </span>
                <div className="floating-label-group grp_baner_modal_container_search_img">
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    onChange={this.queryDelay}
                    value={searchImg}
                    placeholder=" "
                    autoComplete="off"
                  />
                  <label className="floating-label">
                    {" "}
                    Search "engineer", "professional", "manager", etc
                  </label>
                </div>
              </div>

              <span className="grp_baner_modal_container_upload_img_or">
                OR
              </span>

              <div className="grp_baner_modal_container_upload_img">
                <label
                  htmlFor="grp_banner_img_upload_btn"
                  style={{ marginBottom: "0px" }}
                >
                  <span
                    className={`grp_baner_modal_container_upload_img_btn`}
                    style={{ color: "white" }}
                  >
                    <span className="flaticon-upload" />
                    Upload Image
                  </span>
                </label>
                <input
                  id="grp_banner_img_upload_btn"
                  onClick={() => this.handleClick}
                  onChange={this.bannerSelectedHandler}
                  type="file"
                />
              </div>
            </div>

            {bannerImg != null ? (
              <span className="grp_baner_selected_img_container">
                <img
                  src={bannerImg.url}
                  className="grp_baner_selected_img_preview"
                />
                <span
                  className="flaticon-trash"
                  onClick={() => this.removeBannerImg()}
                />
              </span>
            ) : null}

            {setBannerImgPreview && setBannerImgPreview.length > 0 ? (
              <span>
                <span className="grp_baner_modal_container_inst">
                  {" "}
                  Click on image below to select and then
                  <span
                    onClick={this.props.openBannerModal}
                    className="onClick"
                  >
                    close
                  </span>
                  this modal
                </span>

                <div className="grp_baner_modal_image_container">
                  {this.renderUploadPreview(setBannerImgPreview)}
                </div>
              </span>
            ) : null}
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    storyMetricsChange: (data) =>
      dispatch(actionCreators.storyMetricsChange(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BannerModal)
);
